import { render, staticRenderFns } from "./CampaignCreate.vue?vue&type=template&id=55daab71"
import script from "./CampaignCreate.vue?vue&type=script&lang=js"
export * from "./CampaignCreate.vue?vue&type=script&lang=js"
import style0 from "./CampaignCreate.vue?vue&type=style&index=0&id=55daab71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports